import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotix } from "../components/Notix/Notix";
import "./Login.css";
import { 
  createUserWithEmailAndPassword, 
  signInWithPopup, 
  GoogleAuthProvider 
} from "firebase/auth";
import { auth, db } from "../firebase";
import { collection, getDocs, setDoc, doc, serverTimestamp } from "firebase/firestore";
import Privacy from "./Privacy";
import CookieBanner from "./CookieBanner";

// Modal simple para mostrar la política
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
    }}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 24, maxWidth: 750, width: "90%", position: "relative" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 8, right: 12, fontSize: 22, background: "none", border: "none", cursor: "pointer" }}>×</button>
        {children}
      </div>
    </div>
  );
};

const Signup = () => {
  const notix = useNotix();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const navigate = useNavigate();
  const googleProvider = new GoogleAuthProvider();
  const LIMITE_USUARIOS = 100;

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const usersSnapshot = await getDocs(collection(db, "users"));
      if (usersSnapshot.size >= LIMITE_USUARIOS) {
        setError("Se ha alcanzado el límite de 100 usuarios registrados.");
        setLoading(false);
        return;
      }

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        email,
        createdAt: serverTimestamp(),
      });

      notix.success('Registro exitoso', {
        position: 'top-center'
      });
      setEmail("");
      setPassword("");
      navigate("/app"); // Redirige al dashboard
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  const handleGoogleSignup = async () => {
    setError("");
    setLoading(true);
    try {
      const usersSnapshot = await getDocs(collection(db, "users"));
      if (usersSnapshot.size >= LIMITE_USUARIOS) {
        setError("Se ha alcanzado el límite de 100 usuarios registrados.");
        setLoading(false);
        return;
      }

      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Verifica si el usuario ya existe en la colección
      const userDocRef = doc(db, "users", user.uid);
      const userDocSnap = await getDocs(collection(db, "users"));
      if (!userDocSnap.docs.find(doc => doc.id === user.uid)) {
        await setDoc(userDocRef, {
          email: user.email,
          createdAt: serverTimestamp(),
        });
      }

      notix.success("¡Registro/Inicio con Google exitoso!", {
        position: 'top-center'
      });
      navigate("/app"); // Redirige al dashboard
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSignup}>
        <h2>Registro</h2>
        <p className="login-description">Crea una cuenta nueva para comenzar</p>

        <label htmlFor="email">Correo Electrónico</label>
        <input
          type="email"
          id="email"
          required
          value={email}
          placeholder="name@example.com"
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password">Contraseña</label>
        <input
          type="password"
          id="password"
          required
          value={password}
          placeholder="********"
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p style={{ color: "red" }}>{error}</p>}

        <button type="submit" className="sign-in-button" disabled={loading}>
          {loading ? "Registrando..." : "Registrarse"}
        </button>

        <button
          type="button"
          className="google-signin-button"
          onClick={handleGoogleSignup}
          disabled={loading}
          style={{ marginTop: "10px" }}
        >
          {loading ? "Cargando..." : "Registrarse/Iniciar sesión con Google"}
        </button>

        <button type="button" className="back-button" onClick={() => navigate("/login")}>
          Volver
        </button>

        <p className="signup-link">
          ¿Ya tienes cuenta?{" "}
          <button type="button" className="link-button" onClick={() => navigate("/login")}>
            Login
          </button>
        </p>

        {/* Botón de política de privacidad */}
        <button
          type="button"
          className="privacy-btn"
          style={{ marginTop: 24, background: "none", border: "none", color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => setShowPrivacy(true)}
        >
          Política de Privacidad
        </button>
      </form>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)}>
        <Privacy />
      </Modal>

      <CookieBanner />
    </div>
  );
};

export default Signup;
